// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/" + {"134":"error-banner","381":"posts-grid","643":"datadog"}[chunkId] + "." + {"134":"cefdc34b8dfa229154ff","381":"a3b10d5422b05ff7b0cb","643":"c57da36e228ddbf6cd2c"}[chunkId] + ".js";
};